import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getEmployeeId, getUserId } from "../../Base/helper/baseFunctions";
import NProgress from 'nprogress';


export const GetManageGoalHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/pms/ManageGoal/getGoal`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            alignment: params?.alignment
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "Goals retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve goals", hasError: true, data: err?.response?.data }
    });
};

export const AddManageGoalHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/pms/ManageGoal/addGoal`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            goal_sub_category_configuration_fk: +params?.goal_sub_category_configuration_fk,
            goal_desc: params?.goal_desc,
            weight: +params?.weight,
            due_date: params?.due_date,
            alignment: params?.alignment,
            assigned_to: params?.alignment === "Self" ? getEmployeeId() : +params?.employee_id?.employee_id || null,
            goal_status: params?.goal_status?.value,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Goal added successfully");
        return { message: "Goal added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add goal", hasError: true, data: err?.response?.data }
    });
};

export const UpdateManageGoalHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/pms/ManageGoal/updateGoal`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            goal_pk: +params?.goal_pk,
            goal_sub_category_configuration_fk: +params?.goal_sub_category_configuration_fk,
            goal_desc: params?.goal_desc,
            weight: +params?.weight,
            due_date: params?.due_date,
            alignment: params?.alignment,
            assigned_to: params?.alignment === "Self" ? getEmployeeId() :  +params?.employee_id?.employee_id || null,
            goal_status: params?.goal_status?.value,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Goal updated successfully");
        return { message: "Goal updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update goal", hasError: true, data: err?.response?.data }
    });
};

export const DeleteManageGoalHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/pms/ManageGoal/deleteGoal`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            goal_pk: params?.goal_pk
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Goal deleted successfully");
        return { message: "Goal deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete goal", hasError: true, data: err?.response?.data }
    });
};

export const GetMyGoalHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/pms/ManageGoal/getMyGoal`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            assigned_to: getEmployeeId(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "My Goals retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve goals", hasError: true, data: err?.response?.data }
    });
};